import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { Typography, Checkbox, Button, Row, Col, Table, Tabs } from 'antd';
import bronzeMembership from 'static/img/Bronze.png';
import silverMembership from 'static/img/Silver.png';
import goldMembership from 'static/img/Gold.png';

const { Paragraph, Title } = Typography;
const { TabPane } = Tabs;

const dataBronze = [
  {
    Membership: 'Bronze',
    BidFrom: '€ 0',
    BidTo: '€ 999',
    Percentage: '0%',
    Amount: '',
  },
  {
    Membership: 'Bronze',
    BidFrom: '€ 1000',
    BidTo: '€ 4.999',
    Percentage: '10%',
    Amount: '',
  },
  {
    Membership: 'Bronze',
    BidFrom: '€ 5.000',
    BidTo: '€ 6.999',
    Percentage: '',
    Amount: '€ 500',
  },
];

const dataSilver = [
  {
    Membership: 'Silver',
    BidFrom: '€ 0',
    BidTo: '€ 999',
    Percentage: '0%',
    Amount: '',
  },
  {
    Membership: 'Silver',
    BidFrom: '€ 1000',
    BidTo: '€ 4.999',
    Percentage: '8%',
    Amount: '',
  },
  {
    Membership: 'Silver',
    BidFrom: '€ 5.000',
    BidTo: '€ 9.999',
    Percentage: '',
    Amount: '€ 450',
  },
  {
    Membership: 'Silver',
    BidFrom: '€ 10.000',
    BidTo: '-',
    Percentage: '',
    Amount: '€ 700',
  },
];

const dataGold = [
  {
    Membership: 'Gold',
    BidFrom: '€ 0',
    BidTo: '€ 999',
    Percentage: '0%',
    Amount: '',
  },
  {
    Membership: 'Gold',
    BidFrom: '€ 1000',
    BidTo: '€ 4.999',
    Percentage: '7%',
    Amount: '',
  },
  {
    Membership: 'Gold',
    BidFrom: '€ 5.000',
    BidTo: '€ 9.999',
    Percentage: '',
    Amount: '€ 400',
  },
  {
    Membership: 'Gold',
    BidFrom: '€ 10.000',
    BidTo: '-',
    Percentage: '',
    Amount: '€ 650',
  },
];

const columns = [
  {
    title: I.t('MEMBERSHIP'),
    key: 'Membership',
    dataIndex: 'Membership',
    width: 30,
    align: 'center',
  },
  {
    title: I.t('BID_FROM'),
    key: 'BidFrom',
    dataIndex: 'BidFrom',
    width: 30,
    align: 'center',
  },
  {
    title: I.t('BID_TO'),
    key: 'BidTo',
    dataIndex: 'BidTo',
    width: 30,
    align: 'center',
  },
  {
    title: I.t('FEE_PERCENTAGE'),
    key: 'Percentage',
    dataIndex: 'Percentage',
    width: 30,
    align: 'center',
  },
  {
    title: I.t('FEE_AMOUNT'),
    key: 'Amount',
    dataIndex: 'Amount',
    width: 30,
    align: 'center',
  },
];

const imageStyle = {
  height: '32px',
  width: '32px',
  textAlign: 'center',
};

const FeesDocument = ({
  showApproveButton,
  showCheckBox,
  handleCheckBoxChange,
  handleAccept,
}) => {
  return (
    <div style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
      <Title level={4}>
        Παρακαλώ όπως διαβάσετε προσεκτικά την πολιτική χρεώσεων που ισχύει στην
        πλατφόρμα:
      </Title>
      <Paragraph>
        Σε περίπτωση που έχετε την υψηλότερη προσφορά και αποκτήσετε το
        δημοπρατούμενο οχήμα θα χρεωθείτε με την επιπλέον χρέωση βάση του
        παρακάτω πίνακα χρεώσεων ανα membership:
      </Paragraph>
      <Tabs defaultActiveKey="1" style={{ marginBottom: 10 }}>
        <TabPane
          tab={
            <div>
              <span style={{ fontWeight: 600, marginRight: 3 }}>Bronze</span>
              <img style={imageStyle} src={bronzeMembership} alt="" />
            </div>
          }
          key="1"
        >
          <Table
            bordered={true}
            dataSource={dataBronze}
            columns={columns}
            pagination={false}
            size="small"
          />
        </TabPane>
        <TabPane
          tab={
            <div>
              <span style={{ fontWeight: 600, marginRight: 3 }}>Silver</span>
              <img style={imageStyle} src={silverMembership} alt="" />
            </div>
          }
          key="2"
        >
          <Table
            bordered={true}
            dataSource={dataSilver}
            columns={columns}
            pagination={false}
            size="small"
          />
        </TabPane>
        <TabPane
          tab={
            <div>
              <span style={{ fontWeight: 600, marginRight: 3 }}>Gold</span>
              <img style={imageStyle} src={goldMembership} alt="" />
            </div>
          }
          key="3"
        >
          <Table
            bordered={true}
            dataSource={dataGold}
            columns={columns}
            pagination={false}
            size="small"
          />
        </TabPane>
      </Tabs>
      {showCheckBox ? (
        <Row justify="space-between">
          <Col xs={12}>
            <Checkbox onChange={handleCheckBoxChange}>
              <span style={{ fontWeight: 600 }}>
                Να μην εμφανιστεί ξανά αυτό το μήνυμα
              </span>
            </Checkbox>
          </Col>
          <Col xs={6}>
            <Button key="submit" type="primary" onClick={handleAccept}>
              Αποδέχομαι
            </Button>
          </Col>
        </Row>
      ) : showApproveButton ? (
        <Row justify="center">
          <Button key="submit" type="primary" onClick={handleAccept}>
            Αποδέχομαι
          </Button>
        </Row>
      ) : null}
    </div>
  );
};

export default FeesDocument;
